import React, { useEffect, useState } from "react";
import { IPetsyPromotionCodePopup } from "./PetsyPromotionCodePopup.types";
import PetsyCanvasConfetti from "../PetsyCanvasConfetti";
import {
  Modal,
  Button,
} from "react-bootstrap";
import "./PetsyPromotionCodePopup.scss";
import _ from "lodash";
import {
  handleSendKlaviyoEvents,
  Options,
  OptionalLayout,
  OptionElementType,
  subscribeDataChange,
  unsubscribeDataChange,
  setFlowDataDirect,
  getSavedCover,
  FlowTypes
} from "@adaptis/flow-components";

export default function PetsyPromotionCodePopup(props: IPetsyPromotionCodePopup) {
  const [renderKey, setRenderKey] = React.useState(0);
  const [isPhone, setIsPhone] = React.useState<boolean>(false);
  const [promotionCode, setPromotionCode] = React.useState<FlowTypes.IFlowPromotionCode | null>(props.promotionCode ?? null);
  const [countRunEffect, setCountRunEffect] = useState(0);
  const isMobileDevice = () => {
    const userAgent = navigator.userAgent || navigator.vendor;
    const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    const isMobile = mobileRegex.test(userAgent);
    const isSmallScreen = window.innerWidth < 768;
    const hasTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    return isMobile && isSmallScreen && hasTouchScreen;
  };

  React.useEffect(() => {
    setCountRunEffect(current => current + 1);
    setIsPhone(isMobileDevice());
    const handleResize = () => {
      setIsPhone(isMobileDevice());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  function modalClose() {
    props.onClose();
  }

  const optionRef = React.useRef<any>();
  async function handleGetStarted() {
    console.log("handleGetStarted");
  }

  function handleShowContent() {
    return (
      <>
        <div className="ref-row">
          <div className="promotion-code-content">
            <div className="coupon-code">
              <div className="img-wrapper">
                <img src="/images/promotion-code-green-icon.png">
                </img>
              </div>
              <div className="coupon-value-wrapper">
                <span><b>{promotionCode?.promoCode}</b></span>
              </div>
            </div>
            <div className="promotion-code-detail">
              <p>{promotionCode?.promotionMessage}</p>
              <p>Complete your quote below to lock it in</p>
            </div>
          </div>
        </div>
        
        <div className="ref-row mt-3">
          <label className="help text-left">Note, this promo code cannot be combined with a Multi-pet discount. Only one promotion code can be applied per policy.</label>
        </div>
        <div className="ref-row mt-4">
          <Button
            key={renderKey}
            disabled={false}
            className={"flc_next-button btn"}
            onClick={modalClose}
          >
            Get Started
          </Button>
        </div>
      </>
    )
  }

  return (
    <>
      <Modal
        className="flc_petsy-promotion-code-popup"
        show={props.show}
        onHide={modalClose}
        backdrop="static"
        keyboard={false}
        fullscreen="sm-down"
        centered
      >
        <Modal.Header closeButton><div className="modal-title">Promotion code unlocked</div></Modal.Header>
        <Modal.Body className="text-center" ref={optionRef}>
          {handleShowContent()}
        </Modal.Body>
      </Modal>
      {<PetsyCanvasConfetti run={countRunEffect} />}
    </>
  );
}
